import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Slider, Form } from 'antd'
import BasicTooltip from './BasicTooltip'

const SliderInput = props => {
  const [showToolTip, setShowToolTip] = useState(false)
  const {
    toolTipLabel,
    name,
    label,
    toolTipLabel2,
    required,
    value,
    onChange,
    max,
    min,
    range
  } = props

  useEffect(() => {
    toolTipLabel && setShowToolTip(true)
  }, [toolTipLabel])
  return (
    <React.Fragment>
      <Form.Item
        name={name}
        label={
          <>
            {label ? label : ''}{' '}
            {showToolTip ? (
              <>
                <BasicTooltip label={toolTipLabel} label2={toolTipLabel2} />
              </>
            ) : (
              ''
            )}
          </>
        }
        initialValue={value}
        rules={[
          {
            required: required
          }
        ]}
        colon={false}
      >
        <Slider
          value={value}
          name={name}
          onChange={onChange}
          defaultValue={value}
          min={min}
          max={max}
          range={range}
          //   style={{ width: '100%', backgroundColor: '#f2f2f2' }}
          className="form_input_muted"
        />
      </Form.Item>
    </React.Fragment>
  )
}

SliderInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  inputType: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  toolTipLabel: PropTypes.string,
  toolTipLabel2: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  range: PropTypes.bool,
  required: PropTypes.bool
}

export default SliderInput
